import { Map } from "immutable"

import {
    STAKEHOLDER_ADD_NEW as ADD_NEW,
    STAKEHOLDER_APPLY_MODEL_UPDATE as APPLY_MODEL_UPDATE,
    STAKEHOLDER_CANCEL_MODEL_UPDATE as CANCEL_MODEL_UPDATE,
    STAKEHOLDER_CLEAR_FILTER_CRITERIA as CLEAR_FILTER_CRITERIA,
    EVIDENCE_ADD_RESPONSE,
    EVIDENCE_REMOVE_ITEM,
    STAKEHOLDER_ITEM_CACHED_RESPONSE as ITEM_CACHED_RESPONSE,
    STAKEHOLDERS_PAGE_ITEM_REQUEST as ITEM_REQUEST,
    STAKEHOLDERS_PAGE_ITEM_RESPONSE as ITEM_RESPONSE,
    STAKEHOLDER_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    STAKEHOLDER_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    STAKEHOLDERS_PAGE_LIST_REQUEST as LIST_PAGE_REQUEST,
    STAKEHOLDERS_PAGE_LIST_RESPONSE as LIST_RESPONSE,
    STAKEHOLDER_LIST_SEARCH_REQUEST as LIST_SEARCH_REQUEST,
    ROLE_ADD,
    ROLE_APPROVE,
    ROLE_EDIT,
    ROLE_REJECT,
    ROLE_REMOVE,
    STAKEHOLDER_SET_EDIT_MODE as SET_EDIT_MODE,
    STAKEHOLDER_SET_FILTER as SET_FILTER,
    STAKEHOLDER_FINISH_SAVING,
    STAKEHOLDER_SHOW_INVALID_FIELDS,
    STAKEHOLDER_UPDATE_FILTER_TYPE,
    STAKEHOLDER_UPDATE_FILTER_CRITERIA as UPDATE_FILTER_CRITERIA,
    STAKEHOLDER_UPDATE_IMAGE as UPDATE_IMAGE,
    STAKEHOLDER_UPDATE_MODEL as UPDATE_MODEL
} from "../../actions/action-types"
import {
    StakeholderFilterModel,
    updateStakeholderSearchFilterModel
} from "../../models/filters/stakeholder-filter"
import { serialiseSearchCriteria } from "../paging/paging-reducer-utils"
import {
    toUI as stakeholderToUI,
    updateStakeholderChangeModel,
    updateStakeholderCreateModel,
    StakeholderModel,
    StakeholderCreateModel
} from "../../models/entities/stakeholder"
import PresentationReducerBuilder from "./build-presentation-reducer"

export const defaultSearchCriteria = new Map({ name: "" })

const reducerBuilder = new PresentationReducerBuilder()
const defaultReducer = reducerBuilder
    .actionsToHandle({
        UPDATE_IMAGE,
        UPDATE_MODEL,
        APPLY_MODEL_UPDATE,
        CANCEL_MODEL_UPDATE,
        CLEAR_FILTER_CRITERIA,
        UPDATE_FILTER_CRITERIA,
        SET_FILTER,
        SET_EDIT_MODE,
        ITEM_REQUEST,
        ITEM_RESPONSE,
        ITEM_SAVE_RESPONSE,
        STAKEHOLDER_FINISH_SAVING,
        ITEM_CACHED_RESPONSE,
        LIST_PAGE_REQUEST,
        LIST_SEARCH_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        ADD_NEW
    })
    .updateChangeModel(updateStakeholderChangeModel)
    .updateCreateModel(updateStakeholderCreateModel)
    .workingModelToUI(stakeholderToUI)
    .workingModelClass(StakeholderModel)
    .workingFilterModelClass(StakeholderFilterModel)
    .updateSearchFilterModel(updateStakeholderSearchFilterModel)
    .canCancel(() => true)
    .createModelClass(StakeholderCreateModel)
    .defaultState({
        activeFilterType: "",
        workingModel: new StakeholderModel(),
        searchCriteria: serialiseSearchCriteria(defaultSearchCriteria),
        searchFilterModel: defaultSearchCriteria,
        workingFilterModel: new StakeholderFilterModel()
    })
    .build()

export default (state = undefined, action) => {
    const defaultReduction = defaultReducer(state, action)
    const { type } = action
    switch (type) {
        case ROLE_ADD:
            return {
                ...defaultReduction,
                canSave: true,
                isMissingRole: false
            }
        case ROLE_REMOVE:
        case ROLE_EDIT:
        case ROLE_APPROVE:
        case ROLE_REJECT:
        case EVIDENCE_ADD_RESPONSE:
        case EVIDENCE_REMOVE_ITEM:
            return {
                ...defaultReduction,
                canSave: true
            }
        case STAKEHOLDER_FINISH_SAVING:
            return {
                ...defaultReduction,
                canSave: false,
                canCancel: true,
                isEditMode: false,
                isCreateMode: false,
                isSavingItem: false,
                isMissingRole: false
            }
        case STAKEHOLDER_SHOW_INVALID_FIELDS:
            return {
                ...defaultReduction,
                isMissingRole: true,
                isSavingItem: false,
                canSave: true,
                canCancel: true
            }
        case STAKEHOLDER_UPDATE_FILTER_TYPE:
            let fieldToClear

            if (state.activeFilterType === "keyIssue") {
                fieldToClear = "dimension"
            } else {
                fieldToClear = "topic"
            }

            return {
                ...defaultReduction,
                activeFilterType: action.activeFilterType,
                workingFilterModel: defaultReduction.workingFilterModel.set(
                    fieldToClear,
                    ""
                ),
                searchFilterModel: defaultReduction.searchFilterModel.set(
                    fieldToClear,
                    ""
                )
            }
        default:
            return defaultReduction
    }
}
